import { Phone, ShieldCheck, Lock, Clock } from "lucide-react";
import { brand } from "@/data/site/brand";

interface PaidLeadFormProps {
  /** Slug of the paid landing page, used as lead source. */
  source: string;
  /** Primary keyword the visitor searched for, e.g. "austin tax attorney". */
  keyword: string;
  /** Inferred location from the slug, used in microcopy. */
  location?: string;
}

/**
 * Call-only conversion card for paid landing pages. Phone is the only CTA —
 * callback forms are intentionally not offered.
 */
export const PaidLeadForm = (_: PaidLeadFormProps) => {
  return (
    <div className="bg-white rounded-2xl p-6 md:p-7 shadow-2xl ring-1 ring-black/5">
      <div className="text-center mb-4">
        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-urgent mb-1">
          Free · Confidential · No Obligation
        </p>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-navy-dark leading-tight">
          Talk to a CPA about your tax case
        </h2>
      </div>

      <a
        href={`tel:${brand.phoneTel}`}
        className="group block w-full bg-gold hover:bg-gold-light text-navy-dark rounded-xl px-4 py-4 shadow-gold transition-all hover:scale-[1.02] active:scale-[0.99]"
      >
        <div className="flex items-center justify-center gap-3">
          <Phone className="w-6 h-6" />
          <div className="text-left">
            <div className="text-[10px] font-bold uppercase tracking-wider opacity-80">
              Tap to Call · Avg. answer 30s
            </div>
            <div className="text-2xl font-heading font-extrabold leading-none">{brand.phone}</div>
          </div>
        </div>
      </a>

      <p className="mt-3 text-center text-[11px] text-navy-dark/85">
        {brand.hours} · A licensed CPA picks up — no call center.
      </p>

      <ul className="mt-4 space-y-1.5 text-[11px] text-navy-dark/85">
        <li className="flex items-center gap-1.5">
          <ShieldCheck className="w-3 h-3 text-gold-dark" /> Reviewed by a credentialed CPA — not a call center
        </li>
        <li className="flex items-center gap-1.5">
          <Lock className="w-3 h-3 text-gold-dark" /> Confidential under IRS §7216
        </li>
        <li className="flex items-center gap-1.5">
          <Clock className="w-3 h-3 text-gold-dark" /> Same-day answers when you call
        </li>
      </ul>
    </div>
  );
};
